import ReactGA from 'react-ga4';

export const initializeTracker = (googleAnalyticsTagID: string) => {
  ReactGA.initialize(googleAnalyticsTagID);
};

export const setUserID = (userId: string) => {
  ReactGA.set({ userId });
};

export const unsetUserID = () => {
  ReactGA.set({ userId: undefined });
};
